import { createSelector } from 'reselect';
import { type RootState } from "../../../redux/store";

const selectNavBreadcrumbsState = (state: RootState) => state.navigationBreadcrumbs.list;

export const selectNavigationBreadcrumbs = createSelector(
  [selectNavBreadcrumbsState],
  (breadcrumbs) => breadcrumbs
);
